import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { FieldWorkPage } from './field-work.models';
import { Laborer } from './laborer.model';

@Injectable({ providedIn: 'root' })
export class LaborerService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.restApiUrl}laborers`;

  list(owningCompanyId?: number, page = 0, pageSize = 20, search = '') {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (owningCompanyId) params = params.set('owningCompanyId', owningCompanyId);
    if (search) params = params.set('search', search);
    return this.http.get<FieldWorkPage<Laborer>>(this.url, { params });
  }

  save(value: Laborer) {
    return value.id
      ? this.http.put<Laborer>(`${this.url}/${value.id}`, value)
      : this.http.post<Laborer>(this.url, value);
  }
}
